"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RendererV3 = void 0;
var RendererV3 = /** @class */ (function () {
    function RendererV3(canvasSelector, world) {
        var _this = this;
        this.entityCtx = null;
        this.animationFrameId = null;
        this.viewportX = 0;
        this.viewportY = 0;
        this.spriteCache = new Map();
        this.cellSize = 30;
        this.visibleCols = 0;
        this.visibleRows = 0;
        this.prevXArray = null;
        this.prevYArray = null;
        this.lastTickTime = 0;
        this.lastTickCount = 0;
        this.useAnimatedPositions = true;
        this.tickDuration = 500;
        this.slowMotion = true;
        this.slowMotionFactor = 10;
        this.world = world;
        var canvasElement = document.querySelector(canvasSelector);
        if (!canvasElement) {
            throw new Error("Missing Canvas in HTML");
        }
        this.entityCanvas = canvasElement;
        this.entityCtx = this.entityCanvas.getContext("2d");
        window.addEventListener("resize", function () { return _this.handleResize(); });
        this.handleResize();
        this.initAnimationArrays();
        this.startAnimationLoop();
    }
    RendererV3.prototype.startAnimationLoop = function () {
        var _this = this;
        if (this.animationFrameId !== null) {
            cancelAnimationFrame(this.animationFrameId);
        }
        var animate = function () {
            _this.render();
            _this.animationFrameId = requestAnimationFrame(animate);
        };
        this.animationFrameId = requestAnimationFrame(animate);
    };
    RendererV3.prototype.initAnimationArrays = function () {
        var maxEntities = this.world.ecs.getMaxEntities();
        this.prevXArray = new Int32Array(maxEntities);
        this.prevYArray = new Int32Array(maxEntities);
        var xArray = this.world.ecs.data["x"];
        var yArray = this.world.ecs.data["y"];
        if (xArray && yArray) {
            for (var i = 0; i < maxEntities; i++) {
                this.prevXArray[i] = xArray[i];
                this.prevYArray[i] = yArray[i];
            }
        }
        this.lastTickTime = performance.now();
        this.lastTickCount = this.world.ticks;
    };
    RendererV3.prototype.handleResize = function () {
        var container = this.entityCanvas.parentElement || document.body;
        var containerWidth = container.clientWidth;
        var containerHeight = window.innerHeight * 0.7;
        this.visibleCols = Math.floor(containerWidth / this.cellSize);
        this.visibleRows = Math.floor(containerHeight / this.cellSize);
        this.entityCanvas.width = this.visibleCols * this.cellSize;
        this.entityCanvas.height = this.visibleRows * this.cellSize;
        this.render();
    };
    RendererV3.prototype.render = function () {
        if (!this.entityCtx)
            return;
        var ecsData = this.world.ecs.data;
        var activeArray = ecsData["active"];
        var xArray = ecsData["x"];
        var yArray = ecsData["y"];
        var emojiArray = ecsData["emoji"];
        this.entityCtx.clearRect(0, 0, this.entityCanvas.width, this.entityCanvas.height);
        var currentTickCount = this.world.ticks;
        var currentTime = performance.now();
        var tweenFactor = 0;
        var newTickDetected = false;
        if (this.prevXArray && this.prevYArray) {
            var elapsed = currentTime - this.lastTickTime;
            var effectiveDuration = this.tickDuration;
            if (this.slowMotion) {
                effectiveDuration = this.tickDuration * this.slowMotionFactor;
            }
            tweenFactor = Math.min(1.0, elapsed / effectiveDuration);
            if (currentTickCount !== this.lastTickCount) {
                newTickDetected = true;
            }
        }
        var maxEntityId = this.world.maxActiveId;
        for (var i = 0; i <= maxEntityId; i++) {
            if (!activeArray[i])
                continue;
            var sprite = this.getEmojiSprite(emojiArray[i]);
            var renderX = xArray[i];
            var renderY = yArray[i];
            if (this.useAnimatedPositions &&
                this.prevXArray &&
                this.prevYArray &&
                tweenFactor < 1.0) {
                renderX =
                    this.prevXArray[i] + (xArray[i] - this.prevXArray[i]) * tweenFactor;
                renderY =
                    this.prevYArray[i] + (yArray[i] - this.prevYArray[i]) * tweenFactor;
            }
            var x = renderX * this.cellSize + (this.cellSize - sprite.width) / 2;
            var y = renderY * this.cellSize + (this.cellSize - sprite.height) / 2;
            this.entityCtx.drawImage(sprite, x, y);
        }
        if (newTickDetected) {
            this.updatePreviousPositions();
            this.lastTickTime = currentTime;
            this.lastTickCount = currentTickCount;
        }
    };
    RendererV3.prototype.updatePreviousPositions = function () {
        if (!this.prevXArray || !this.prevYArray)
            return;
        var xArray = this.world.ecs.data["x"];
        var yArray = this.world.ecs.data["y"];
        var activeArray = this.world.ecs.data["active"];
        if (xArray && yArray) {
            var maxEntityId = this.world.maxActiveId;
            for (var i = 0; i <= maxEntityId; i++) {
                if (activeArray[i]) {
                    this.prevXArray[i] = xArray[i];
                    this.prevYArray[i] = yArray[i];
                }
            }
        }
    };
    RendererV3.prototype.forcePositionUpdate = function () {
        if (!this.prevXArray || !this.prevYArray) {
            console.warn("Previous position arrays not initialized");
            return;
        }
        var xArray = this.world.ecs.data["x"];
        var yArray = this.world.ecs.data["y"];
        var activeArray = this.world.ecs.data["active"];
        for (var i = 0; i <= this.world.maxActiveId; i++) {
            if (activeArray[i]) {
                this.prevXArray[i] = xArray[i];
                this.prevYArray[i] = yArray[i];
            }
        }
        this.render();
    };
    RendererV3.prototype.setCellSize = function (size) {
        if (size > 0) {
            this.cellSize = size;
            this.spriteCache.clear();
            this.handleResize();
        }
    };
    RendererV3.prototype.getEmojiSprite = function (emoji) {
        var cacheKey = "".concat(emoji, "_").concat(Math.round(this.cellSize));
        if (this.spriteCache.has(cacheKey)) {
            return this.spriteCache.get(cacheKey);
        }
        var spriteSize = this.cellSize * 0.9;
        var spriteCanvas = document.createElement("canvas");
        spriteCanvas.width = spriteSize;
        spriteCanvas.height = spriteSize;
        var spriteCtx = spriteCanvas.getContext("2d");
        spriteCtx.clearRect(0, 0, spriteCanvas.width, spriteCanvas.height);
        spriteCtx.textAlign = "center";
        spriteCtx.textBaseline = "middle";
        spriteCtx.font = "".concat(spriteSize * 0.8, "px Arial");
        spriteCtx.fillText(emoji, spriteCanvas.width / 2, spriteCanvas.height / 2);
        this.spriteCache.set(cacheKey, spriteCanvas);
        return spriteCanvas;
    };
    RendererV3.prototype.toggleAnimatedPositions = function () {
        this.useAnimatedPositions = !this.useAnimatedPositions;
    };
    RendererV3.prototype.toggleSlowMotion = function () {
        this.slowMotion = !this.slowMotion;
    };
    return RendererV3;
}());
exports.RendererV3 = RendererV3;
